import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.insightsApiUrl, {
  camelizeKeys: true,
});

export type SignalType = 'community_sentiment_spike' | 'content_performance';

export type ProductArea = 'community' | 'dashboards' | 'analytics';

export type InsightInteractionType = 'dismissed' | 'actioned';

export interface InsightUserInteraction {
  firstViewedAt: string | null;
  interactedAt: string | null;
  interactionType: InsightInteractionType | null;
}

export interface InsightSummary {
  id: number;
  brandId: number;
  productAreas: string;
  headline: string;
  signalType: SignalType;
  signalSubtype: string | null;
  detectedAt: string;
  userInsightInteraction: InsightUserInteraction | null;
}

interface ListInsightsResponse {
  data: InsightSummary[];
}

export async function listInsights(
  { brandIds }: { brandIds: number[] },
  config: HttpRequestConfig = {},
) {
  return http.get<ListInsightsResponse>('/insights', {
    ...config,
    params: { brand_ids: brandIds.join(','), ...config.params },
  });
}

export interface RecordInsightInteractionPayload {
  insightId: number;
  firstViewedAt?: string;
  interactionType?: InsightInteractionType;
  interactedAt?: string;
}

export async function recordInsightInteraction(
  { insightId, firstViewedAt, interactionType, interactedAt }: RecordInsightInteractionPayload,
  config: HttpRequestConfig = {},
) {
  const body: Record<string, string> = {};
  if (firstViewedAt) body.firstViewedAt = firstViewedAt;
  if (interactionType) {
    body.interactionType = interactionType;
    body.interactedAt = interactedAt ?? new Date().toISOString();
  }
  return http.post(`/insights/${insightId}/interaction`, body, config);
}
